<template>
  <div>
    <transition name="fade" mode="out-in">
      <div class="card p-4 mb-3">
        <h5 class="helper text-red">
          <vue-typer
            :text="[msg]"
            id="typer"
            :repeat="0"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="70"
            :type-delay="30"
            :pre-erase-delay="1500"
            :erase-delay="10"
            erase-style="backspace"
            :erase-on-complete="false"
            @typed="
              typingOver();
              colorNumbers();
            "
            @typed-char="onTypedChar"
          ></vue-typer>
        </h5>
      </div>
    </transition>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";
import typer from "./../../utilities/typer.js";
import { mapState } from "vuex";

export default {
  extends: typer,
  components: {
    VueTyper,
  },
  data() {
    return {
      isTypingOver: false,
      countWord: 0,
    };
  },
  computed: {
    msg() {
      /*** FORM INSURANCE ***/
      if (this.$router.currentRoute.name == "form-insurance")
        return "Bonjour, répondez à ces 9 petites questions pour recevoir la meilleure proposition d'assurance.\n\nNous résilions pour vous votre assurance habitation actuelle si elle date de + de 12 mois. Si ce n'est pas le cas, un peu de patience et revenez vers nous un peu avant la date d'anniversaire  🎂 de votre contrat.";
      /*** FORM HUNTER ***/
      if (this.$router.currentRoute.name == "form-hunter")
        return "Bonjour, répondez à ces 9 petites questions pour que nos chasseurs puissent trouver le bien de vos rêves.";
      /*** FORM REFURBISHMENT ***/
      if (this.$router.currentRoute.name == "form-refurbishment")
        return "Bonjour, répondez à ces 9 petites questions pour être mis en relation avec les meilleurs entrepreneurs.\n\n⚠️ Uniquement disponible pour la région Ile de France, et les secteurs de Lyon et Bordeaux.";
      /*** FORM GUARANTOR ***/
      if (
        this.$router.currentRoute.name == "form-guarantor" &&
        this.savings === null &&
        this.isFirstStepView == true
      )
        return "Bonjour, répondez à ces quelques questions pour que j'estime si je peux me porter garant de votre location.\n\nRéponse en 24 heures 🌈 !";
      if (this.$router.currentRoute.name == "form-guarantor" && this.savings >= 1)
        return "Un référent de confiance est une personne qui vous reconnait comme étant un locataire sérieux. Sa présence rassure le propriétaire, ce qui maximise vos chances d’être accepté·e.\n\n💡 Le référent de confiance n’a aucune responsabilité légale envers le bailleur.";
      /*  if (this.$router.currentRoute.name == "form-guarantor" && this.isSecondStepView)
        return "🔒 Vos documents sont stockés en toute sécurité chez notre partenaire garant.\n\nIls seront supprimés à la fin de la location de votre appartement.\n\nℹ️ Votre pièce d'idendité peut-être : un passeport, une carte d'identité ou un titre de séjour"; */
    },
    ...mapState({
      monthlyRevenues: state => state.optionalFields.monthlyRevenues,
      savings: state => state.optionalFields.savings,
      professionalStatus: state => state.optionalFields.professionalStatus,
      isSecondStepView: "isSecondStepView",
      isFirstStepView: "isFirstStepView",
      id: state => state.optionalFields.id,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/cards.scss";

.helper {
  text-align: left;
  margin-bottom: 0;
}
::v-deep {
  .vue-typer .custom.caret {
    display: none;
  }
}
</style>
